const ASSOC_PROP_PREFIX = 'assoc_prop:';

export function encodeAssocPropKey(assoc: string, prop: string): string {
  return `${ASSOC_PROP_PREFIX}${assoc}:${prop}`;
}

export function decodeAssocPropKey(
  key: string,
  knownAssocNames: string[]
): { association: string; property: string } | null {
  if (!key.startsWith(ASSOC_PROP_PREFIX)) {
    return null;
  }
  const rest = key.slice(ASSOC_PROP_PREFIX.length);
  const match = knownAssocNames
    .filter(name => rest.startsWith(name + ':'))
    .sort((a, b) => b.length - a.length)[0];
  if (!match) {
    return null;
  }
  return { association: match, property: rest.slice(match.length + 1) };
}
